import type { StaticEntityType, StaticLayerPayload } from "@config";
import { useViewContext } from "@editor-providers";
import { type ComponentType, memo } from "react";

export const Container = memo(
  ({
    entity,
    views,
  }: {
    entity: StaticEntityType;
    views: Record<string, ComponentType<StaticLayerPayload>>;
  }) => {
    const { view } = useViewContext();
    const View = views[view] || views.default;
    return <View entity={entity} />;
  },
  (prev, next) => prev.entity.id === next.entity.id,
);
